import { EditCashAccountBalanceModal } from '../../CashAccount';
import { EditInvestmentBalanceModal } from '../../Investment';
import { EditLoanBalanceModal } from '../../Loan';
import { RealEstateEditModalForm } from '../../RealEstateProperty';
import { EditBusinessValueModalForm } from '../../Business';
import { EditPersonalPropertyItemBalanceModal } from '../../PersonalPropertyItem';
import { EditNoteReceivableBalanceModal } from '../../NoteReceivable';
import { Account } from '../../util';

export const EditAccountValueModal: React.FC<{
  account: Account;
  householdID: string;
  onClose: () => void;
  afterUpdate?: (account: Account) => Promise<void>;
}> = ({ account, onClose, afterUpdate }) => {
  switch (account.__typename) {
    case 'CashAccount':
      return <EditCashAccountBalanceModal cashAccount={account} onClose={onClose} afterUpdate={afterUpdate} />;
    case 'Investment':
      return <EditInvestmentBalanceModal investment={account} onClose={onClose} afterUpdate={afterUpdate} />;
    case 'Loan':
      return <EditLoanBalanceModal loan={account} onClose={onClose} afterUpdate={afterUpdate} />;
    case 'RealEstate':
      return (
        <RealEstateEditModalForm
          realEstate={account}
          householdID={account.householdID}
          onSave={onClose}
          onCancel={onClose}
          afterUpdate={afterUpdate}
        />
      );
    case 'Business':
      return (
        <EditBusinessValueModalForm business={account} onSave={onClose} onCancel={onClose} afterUpdate={afterUpdate} />
      );
    case 'PersonalPropertyItem':
      return (
        <EditPersonalPropertyItemBalanceModal
          personalPropertyItem={account}
          onSave={onClose}
          onCancel={onClose}
          afterUpdate={afterUpdate}
        />
      );
    case 'NoteReceivable':
      return (
        <EditNoteReceivableBalanceModal
          noteReceivable={account}
          onSave={onClose}
          onCancel={onClose}
          afterUpdate={afterUpdate}
        />
      );
    default:
      return <></>;
  }
};
